import {
  CLEAR_ORDER_CONFIRM_CART,
  SET_ORDER_CONFIRM_CART,
} from '../actions/types';
import { defaultState } from '../models/europrisme';

const initialState = {
  cartData: null,
  orderData: null,
  ...defaultState,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ORDER_CONFIRM_CART: {
      return { ...state, ...action.payload };
    }

    case CLEAR_ORDER_CONFIRM_CART: {
      return { ...state, cartData: null, orderData: null };
    }

    default:
      return state;
  }
};
